import { CreateColaborator, Colaborator, UpdateColaborator } from '@/entities/colaborator';
import { ColaboratorService } from '@/services/ColaboratorService';
import { useEffect, useState } from 'react';

export function useColaborator() {
  const [ColaboratorsUse, setColaborators] = useState<Colaborator[]>([]);
  const [linkedColaborators, setLinkedColaborators] = useState<Colaborator[]>([]);
  const [fetchColaboratorError, setFetchColaboratorError] = useState(false);
  const [linkColaborator, setLinkColaborator] = useState<Colaborator[]>([]);
  const [admins, setAdmins] = useState<Colaborator[]>();
  const [getColaboratorsError, setGetColaboratorsError] = useState(false);
  const [createColaboratorError, setCreateColaboratorError] = useState(false);
  const [open, setOpen] = useState(false);
  const [editColaborator, setEditColaborator] = useState(false);
  const [selectedColaborator, setSelectedColaborator] = useState<Colaborator | null>(null);
  const [idToEdit, setIdToEdit] = useState<number>(NaN);

  const fetchColaborator = async () => {
    try {
      const response = await getAllColaborators();
    } catch (error) {
      console.error('Falha ao carregar dados de produtos: ', error);
      setFetchColaboratorError(true);
    }
  };

  useEffect(() => {

    fetchColaborator();
    getNotLinkedCollaborators();
  }, []);

  const getAllColaborators = async () => {
    try {
      const response = await ColaboratorService.getAllColaborator();
      if (response) {
        const colaborators = response.map((data) => ({
          id: data.id,
          name: data.name,
          cellPhone: data.cellPhone,
          colaboratorId:data.colaboratorId,
          isAdmin: data.isAdmin,
          company: data.company,
          email: data.email,
          companyId: data.companyId,

        })).sort((a, b) => a.id - b.id);
        setColaborators(colaborators);
        return colaborators;
      }
    } catch (error) {
      console.error('Falha ao carregar dados de produtos: ', error);
      setGetColaboratorsError(true);
    }
  };

  const getNotLinkedCollaborators = async () => {
    try {
      const response = await ColaboratorService.getNotLinkedCollaborators();
      if (response) {
        const colaborators = response.map((data) => ({
          id: data.id,
          name: data.name,
          cellPhone: data.cellPhone,
          colaboratorId:data.colaboratorId,
          isAdmin: data.isAdmin,
          email: data.email,
          companyId: data.companyId,

        })).sort((a, b) => a.id - b.id);
        setLinkedColaborators(colaborators);
        return colaborators;
    } 
  } catch (e){
      console.error(e);
    }
  }

  const getAllColaborators2 = async (): Promise<Colaborator[] | null> => {
    try {
      const response = await ColaboratorService.getAllColaborator();
      if (response) {
        const colaborators = response.map((data) => ({
          id: data.id,
          name: data.name,
          email: data.email,
          companyId: data.companyId,

        })).sort((a, b) => a.id - b.id);
        return colaborators;
      }
      return null;
    } catch (error) {
      console.error('Falha ao carregar dados de produtos: ', error);
      setGetColaboratorsError(true);
      return null;
    }
  };

  const createColaborator = async (Colaborator: CreateColaborator): Promise<Colaborator | null> => {
    try {
      const response = await ColaboratorService.createColaborator(Colaborator);
      if (response) {
        return response;
      }
    } catch (error) {
      console.error('Falha ao criar produto: ', error);
      setCreateColaboratorError(true);
    }
    return null;
  };

  const updateColaborator = async (ColaboratorId: number, Colaborator: UpdateColaborator) => {
    try {
      await ColaboratorService.updateColaborator(ColaboratorId, Colaborator);
      fetchColaborator();
    } catch (error) {
      console.error('Falha ao atualizar produtos: ', error);
    }
  };

  const deleteColaborator = async (id: number) => {
    try {
      await ColaboratorService.deleteColaborator(id);
    } catch (error) {
      console.error('Falha ao deletar produtos: ', error);
    }
  };

  const getAllAdmin = async () => {
    try {
      const response = await ColaboratorService.getAllAdmin();
      if (response) {
        const colaborators = response.map((data) => ({
          id: data.id,
          name: data.name,
          cellPhone: data.cellPhone,
          isAdmin: data.isAdmin,
          email: data.email,
          companyId: data.companyId,
        })).sort((a, b) => a.id - b.id);

        setAdmins(colaborators);
        return colaborators;
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  };


  return {
    linkedColaborators,
    ColaboratorsUse,
    fetchColaboratorError,
    createColaboratorError,
    selectedColaborator,
    open,
    editColaborator,
    idToEdit,
    getAllAdmin,
    setSelectedColaborator,
    createColaborator,
    updateColaborator,
    deleteColaborator,
    setOpen,
    setEditColaborator,
    setIdToEdit,
    getAllColaborators2
  };
}
